import {Component, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {lastValueFrom} from "rxjs";
import {PerFormaAPIService, ForgotPasswordRequest} from "src/app/services/pfapi.service";

@Component({
    selector: "app-forgot-password",
    templateUrl: "./forgot-password.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent {
    form: FormGroup;
    submitting = false;
    submitted = false;
    errorMessage = "";

    constructor(
        private readonly fb: FormBuilder,
        private readonly api: PerFormaAPIService
    ) {
        this.form = this.fb.group({
            email: ["", [Validators.required]]
        });
    }

    async onSubmit(): Promise<void> {
        this.errorMessage = "";

        if (this.form.invalid) {
            this.form.get("email")?.markAsTouched();
            return;
        }

        const request: ForgotPasswordRequest = {Email: this.form.value.email};

        this.submitting = true;
        try {
            // the endpoint always returns 200 (it never reveals whether the account exists)
            await lastValueFrom(this.api.postApiAuthForgotPassword(request));
            this.submitted = true;
        } catch {
            this.errorMessage = "Something went wrong. Please try again.";
        } finally {
            this.submitting = false;
        }
    }
}
